/// <reference path="./dto/com.rico.sb2.service.system.ts" />

import {jQuery, moment} from './boot'
import {WebSocketClient} from "./WebSocketClient";
import {createHtmlElement} from "./lib/domFunctions";
import {escapeHTML} from "./lib/escapeHTML";
import {AppConfig} from "./AppConfig";
import JournalListItem = com.rico.sb2.service.system.JournalListItem;

const CHILD_LIMIT = 100;

export class JournalPage {
	private readonly ws: WebSocketClient;
	private readonly tableBody: HTMLTableSectionElement;

	constructor(realtime: boolean) {
		this.ws = WebSocketClient.instance();

		this.initDatepicker(document.querySelector('input[name="dateFrom"]')!);
		this.initDatepicker(document.querySelector('input[name="dateTo"]')!);

		const table = document.getElementById('journal') as HTMLTableElement
		this.tableBody = table.tBodies.item(0)!!

		if (realtime) {
			this.ws.subscribe('/topic/journal', m => this.onJournalUpdate(m))
		} else {
			jQuery(table).bootstrapTable({
				url: `${AppConfig.CP}/journal/search-page`,
				sidePagination: 'server',
				queryParams: (params) => {
					params.dateFrom = document.querySelector<HTMLInputElement>('[name="dateFrom"]')!.value;
					params.dateTo = document.querySelector<HTMLInputElement>('[name="dateTo"]')!.value;
					params.code = document.querySelector<HTMLInputElement>('[name="code"]')!.value;
					params.level = document.querySelector<HTMLInputElement>('[name="level"]')!.value;
					return params;
				},
				rowStyle: (row, index) => {
					let eventLiClass = "";
					switch (row.level) {
						case 'ERROR':
							eventLiClass = 'alert alert-danger';
							break;
						case 'WARNING':
							eventLiClass = 'alert alert-warning';
							break;
						case 'TRACE':
							eventLiClass = 'alert alert-info';
							break;
						case 'INFO':
							eventLiClass = 'alert alert-default';
							break;
					}
					console.info([row, index, eventLiClass])
					return ({classes: `${eventLiClass}`})
				},
				responseHandler: (res) => ({total: res.totalElements, rows: res.content}),
				columns: [
					{
						formatter: (value: any, row: any, index: any) => {
							return escapeHTML(moment(row.time).format('DD.MM.YYYY HH:mm:ss'))
						}
					},
					{},
					{},
					{},
					{}
				]
			})

		}

	}

	private onJournalUpdate(m: JournalListItem) {
		this.tableBody.prepend(createHtmlElement('tr', {}, `
<tr>
	<td>${moment(m.time).format('DD.MM.YYYY HH:mm:ss')}</td>
	<td>${escapeHTML(m.code)}</td>
	<td>${escapeHTML(m.level)}</td>
	<td>${escapeHTML(m.userName)}</td>
	<td>${escapeHTML(m.message)}</td>
</tr>		
		`));

		while (this.tableBody.childElementCount > CHILD_LIMIT) {
			this.tableBody.lastElementChild?.remove()
		}
	}


	private initDatepicker(node: HTMLInputElement) {
		const nodeJq = jQuery(node);
		const options = {
			language: AppConfig.locale,
			todayBtn: true,
			todayHighlight: true,
			clearBtn: true
		}

		nodeJq
			.datepicker(options)
		// .datepicker('setDate', new Date())
		// .datepicker('setEndDate', new Date())
	}
}